module.exports = __webpack_public_path__ + "img/thumbnail_PygmyHippo_m_normal.906f86f8.png";